export const environment = {
  env: "test",
  production: true,
  CAMP_NAME: '/localhost:8080',
  API_URL: 'https://proxy.signor-prestito.com/lead-api/api/',
  PATH_CONFIG: 'assets/config/config.json'
};
